import {
    mapState
} from "vuex";
let cardType = "";
let changeType = '';
// 修改证件类别
export function changeCardType(val, type = '') {
    cardType = val;
    changeType = type;
};

// 验证姓名
export function validateName(rule, value, callback) {
    const realnameReg = /^([a-zA-Z0-9\u4e00-\u9fa5\·]{2,10})$/;
    if (!value) {
        return callback(new Error("姓名不能为空"));
    }
    setTimeout(() => {
        if (!realnameReg.test(value)) {
            return callback(new Error("姓名格式错误,请输入英文或汉字"));
        } else {
            callback();
        }
    }, 100);
};

// 验证正整数
export function validateInteger(rule, value, callback) {
    const reg = /^[1-9][0-9]*$/;
    if (!value) {
        return callback(new Error("请填写数字"));
    } else if (!reg.test(value)) {
        return callback(new Error("请填写正确数字"));
    } else {
        callback();
    }
};

// 手机号码验证
export function validatePhone(rule, value, callback) {
    const reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
    if (!value) {
        return callback(new Error("请填写手机号码"));
    } else if (!reg.test(value)) {
        return callback(new Error("请填写正确的手机号码"));
    } else {
        callback();
    }
};

export function validateBankNum(rule, value, callback) {
    const strBin = '10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,68,69,84,87,88,94,95,98,99'
    if (!value) {
        return callback(new Error('收款账户不能为空'))
    } else if (!Number.isInteger(+value)) {
        callback(new Error('银行卡号必须全为数字'))
    } else if (value.trim().length < 12 || value.trim().length > 19) {
        callback(new Error('银行卡号长度必须在12到19之间'))
    } else if (strBin.indexOf(value.substring(0, 2)) === -1) {
        callback(new Error('银行卡号开头6位不符合规范'))
    } else {
        callback()
    }
};

// 证件号码验证
export function idNumber(rule, value, callback) {
    switch (cardType) {
        // 内地居民身份证
        case "身份证":
            idCardValid(rule, value, callback);
            break;
            // 香港居民身份证
        case "HkIdCard":
            isHKCard(rule, value, callback);
            break;
            // 台湾居民往来大陆通行证
        case "TwPass":
            isTWCard(rule, value, callback);
            break;
            // 护照 
        case "护照":
            isPassPortCard(rule, value, callback);
            break;
            // 军官证
        case "OfficerIdCard":
            isOfficerCard(rule, value, callback);
            break;
            // 其他有效国籍旅行证件
        case "其他":
            callback();
            break;
        default:
            if (changeType == 0) {
                if (value) {
                    return callback(new Error("请先选择证件类型"));
                }
            } else {
                if (!value) {
                    return callback(new Error("证件号不能为空"));
                } else {
                    return callback(new Error("请先选择证件类型"));
                }
            }
    }
};

export function idNumber1(rule, value, callback) {
    console.log(rule, value, callback, cardType)
    switch (cardType) {
        // 内地居民身份证
        case "身份证":
            idCardValid(rule, value, callback);
            break;
            // 护照 
        case "护照":
            isPassPortCard(rule, value, callback);
            break;
            // 其他
        case "其他":
            callback();
            break;
        default:
            if (changeType == 0) {
                if (value) {
                    return callback(new Error("请先选择证件类型"));
                }
            } else {
                if (!value) {
                    return callback(new Error("证件号不能为空"));
                } else {
                    return callback(new Error("请先选择证件类型"));
                }
            }
    }
};
// 身份证验证
function idCardValid(rule, value, callback) {
    // 1 "验证通过!", 0 //校验不通过
    const format = /^(([1][1-5])|([2][1-3])|([3][1-7])|([4][1-6])|([5][0-4])|([6][1-5])|([7][1])|([8][1-2]))\d{4}(([1][9]\d{2})|([2]\d{3}))(([0][1-9])|([1][0-2]))(([0][1-9])|([1-2][0-9])|([3][0-1]))\d{3}[0-9xX]$/;
    //号码规则校验
    if (!value) {
        return callback(new Error("身份证号码不能为空"));
    } else if (!format.test(value)) {
        return callback(new Error("身份证号码不合规"));
    }
    //区位码校验
    //出生年月日校验   前正则限制起始年份为1900;
    var year = value.substr(6, 4), //身份证年
        month = value.substr(10, 2), //身份证月
        date = value.substr(12, 2), //身份证日
        time = Date.parse(month + '-' + date + '-' + year), //身份证日期时间戳date
        now_time = Date.parse(new Date()), //当前时间戳
        dates = (new Date(year, month, 0)).getDate(); //身份证当月天数
    if (time > now_time || date > dates) {
        return callback(new Error("出生日期不合规"));
    }
    //校验码判断
    var c = new Array(7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2); //系数
    var b = new Array('1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2'); //校验码对照表
    var id_array = value.split("");
    var sum = 0;
    for (var k = 0; k < 17; k++) {
        sum += parseInt(id_array[k]) * parseInt(c[k]);
    }
    if (id_array[17].toUpperCase() != b[sum % 11].toUpperCase()) {
        return callback(new Error("身份证校验码不合规"));
    }
    callback();
};
// 香港居民身份证验证
function isHKCard(rule, value, callback) {
    // 港澳居民来往内地通行证
    // 规则： H/M + 10位或6位数字
    // 样本： H1234567890
    var reg = /^([A-Z]\d{6,10}(\(\w{1}\))?)$/;
    if (!value) {
        return callback(new Error("请填写港澳居民来往内地通行证号码"));
    } else if (!reg.test(value)) {
        return callback(new Error("港澳居民来往内地通行证号码不合规"));
    } else {
        callback();
    }
};
// 台湾居民来往大陆通行证 验证
function isTWCard(rule, value, callback) {
    // 台湾居民来往大陆通行证
    // 规则： 新版8位或18位数字， 旧版10位数字 + 英文字母
    // 样本： 12345678 或 1234567890B
    var reg = /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/;
    if (!value) {
        return callback(new Error("请填写台湾居民来往大陆通行证号"));
    } else if (!reg.test(value)) {
        return callback(new Error("台湾居民来往大陆通行证号码不合规"));
    } else {
        callback();
    }
};
// 护照验证
function isPassPortCard(rule, value, callback) {
    // 护照
    // 规则： 14/15开头 + 7位数字, G + 8位数字, P + 7位数字, S/D + 7或8位数字,等
    // 样本： 141234567, G12345678, P1234567
    var reg = /^([a-zA-z]|[0-9]){5,17}$/;
    if (!value) {
        return callback(new Error("请填写护照号码"));
    } else if (!reg.test(value)) {
        return callback(new Error("护照号码不合规"));
    } else {
        callback();
    }
};
// 军官证验证
function isOfficerCard(rule, value, callback) {
    // 军官证
    // 规则： 军/兵/士/文/职/广/（其他中文） + "字第" + 4到8位字母或数字 + "号"
    // 样本： 军字第2001988号, 士字第P011816X号
    var reg = /^[\u4E00-\u9FA5](字第)([0-9a-zA-Z]{4,8})(号?)$/;
    if (!value) {
        return callback(new Error("请填写军官证号"));
    } else if (!reg.test(value)) {
        return callback(new Error("军官证号不合规"));
    } else {
        callback();
    }
};

function isAccountCard(rule, value, callback) {
    // 户口本
    // 规则： 15位数字, 18位数字, 17位数字 + X
    // 样本： 441421999707223115
    var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    if (!value) {
        return callback(new Error("请填写户口本号码"));
    } else if (!reg.test(value)) {
        return callback(new Error("户口本号码不合规"));
    } else {
        callback();
    }
};
export default {
    // 正整数
    validateInteger,
    // 证件类型
    changeCardType,
    // 验证姓名
    validateName,
    // 手机号
    validatePhone,
    // 证件号码验证
    idNumber,
    idNumber1,
    // 身份证
    idCardValid,
    // 港澳居民来往内地通行证
    isHKCard,
    // 台湾居民来往大陆通行证
    isTWCard,
    // 护照
    isPassPortCard,
    // 军官证
    isOfficerCard,
    // 户口本
    isAccountCard,
    validateBankNum,
    data() {
        return {

        };
    },
    computed: {
        ...mapState('d2admin/userInfo', [
            'userinfo'
        ])
    },
    created() {},
    methods: {
        // 自动替换filter类的[xx]
        filterReplace(str, watch) {
            var reg = /\[(.+?)\]/g;
            var r = /\[(.+?)\]/;
            var findStr = str.match(reg);
            var info = this.userinfo;
            if (findStr) {
                for (var i = 0; i < findStr.length; i++) {
                    var check = findStr[i].substr(1, findStr[i].length - 2);
                    if (check == "info.Code") {
                        str = str.replace(r, info.uInfo.Code);
                    }
                }
            }
            return str;
        },
        filterArraryReplace(str, watch){
            console.log('str, watch',str, watch);
            var reg = /\[(.+?)\]/g;
            var r = /\[(.+?)\]/;
            var info = this.userinfo;
            str.forEach(v => {
                var findStr = v.value.toString().match(reg);
                if (findStr) {
                    for (var i = 0; i < findStr.length; i++) {
                        var check = findStr[i].substr(1, findStr[i].length - 2);
                        if (check == "info.Code") {
                            v.value = v.value.replace(r, info.uInfo.Code);
                        }
                    }
                }
            });
            return str;
        },
        screenReplace(array) {
            var str = "[CustomFormConfig].[ShortTitle] in (";
            for (var i = 0; i < array.length; i++) {
                str += " '" + array[i] + "',";
            }
            str = str.substr(0, str.length - 1);
            str += ")";
            return str;
        },
        notPushReplace(array) {
            var str = "[CustomFormConfig].[ShortTitle] not in (";
            for (var i = 0; i < array.length; i++) {
                str += " '" + array[i] + "',";
            }
            str = str.substr(0, str.length - 1);
            str += ")";
            return str;
        },
    },
}